import { cn } from '@/lib/utils';
import { LucideProps } from 'lucide-react';

export const CheckmarkIcon = ({ size = 24, strokeWidth = 1.5, className, ...props }: LucideProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={cn('rounded-full bg-primary stroke-white flex-shrink-0', className)}
      {...props}
    >
      <path
        d="M17.3337 8.6665L10.0003 15.9998L6.66699 12.6665"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
